import axios from 'axios'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { backRemu } from '../../urlApi'
import { formatDateH } from '../../helpers/helpersFunction'
import { useState } from 'react'
import logo from '../../assets/LOGO_WebSal.png'
import Swal from 'sweetalert2'

export const AdminVacaciones = () => {

    const {hash,conid} = useParams()

    const id = hash.split('&')[1]

    // console.log(id,'id')

    const [solicitud, setSolicitud] = useState()
    const [dataConid, setDataConid] = useState()

    const getSolicitud = async () => {

        if(!id){window.location.href = "https://www.websal.com"}

        try {
            const response = await axios.get(`${backRemu}vacaciones/get-solicitud-by-id/${id}`)
            console.log(response.data)

            if(+response.data.solicitud.conid !== +conid){window.location.href = "https://www.websal.com"}
            if(response.data.solicitud.estado !== 'P' ){window.location.href = "https://www.websal.com"}

            setSolicitud(response.data.solicitud)
            setDataConid(response.data.dataConid)

        } catch (error) {
            console.log(error)
        }

    }

    useEffect(() => {
        getSolicitud()
    }, [])
    
    const aceptarSolicitud = async() => {

        try {
            
             await axios.get(`${backRemu}vacaciones/aceptar-solicitud/${id}`);

      
            Swal.fire({
                title: "Solicitud Aceptada",
                confirmButtonText: "Ok",
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    window.location.href = "https://www.websal.com"
                } else if (result.isDenied) {
                    window.location.href = "https://www.websal.com"
                }
            });
            
        } catch (error) {
            console.log(error)
        }

     
        
    }


    const rechazarSolicitud = async() => {

        try {
            
            await axios.get(`${backRemu}vacaciones/rechazar-solicitud/${id}`);

     
           Swal.fire({
               title: "Solicitud Rechazada",
               confirmButtonText: "Ok",
           }).then((result) => {
               /* Read more about isConfirmed, isDenied below */
               if (result.isConfirmed) {
                   window.location.href = "https://www.websal.com"
               } else if (result.isDenied) {
                   window.location.href = "https://www.websal.com"
               }
           });
           
       } catch (error) {
           console.log(error)
       }


    }


    // console.log(dataConid,'dataConid')

  return (
    <div style={{ width:'100%', height:'100vh', display:'flex', flexDirection:'column' , justifyContent:'center', alignItems:'center'  }} >
        
        <div>
            <img width='200px' src={logo} />
        </div>

        <div style={{ maxWidth:'50rem', minWidth:'30rem',  width: '100%',  backgroundColor:'white', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)', borderRadius:'0.5rem' }} >

          <p style={{textAlign:'center', fontSize:'1.75rem'}} >Administra vacaciones</p>

                {
                    solicitud && dataConid && 

                    <div style={{height:'100%'  }}>

                            <div>
                                <p style={{textAlign:'center', fontSize:'1.7rem', fontWeight:'bold' }} >Colaborador: {dataConid?.nombre} {dataConid?.app} {dataConid?.apm} {dataConid?.rut}  </p> 
                            </div>

                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", textAlign: "center", fontSize: "1.7rem" }}>
                                <p><strong>DESDE</strong></p>
                                <p><strong>HASTA</strong></p>
                                <p><strong>DÍAS HÁBILES</strong></p>

                                <p>{formatDateH(solicitud.desde)}</p>
                                <p>{formatDateH(solicitud.hasta)}</p>
                                <p>{solicitud.diash}</p>
                            </div>

                            <div>
                                <p style={{textAlign:'center', fontSize:'1.7rem',}} >Fecha Solicitud: {formatDateH(solicitud.created_at)} </p> 
                            </div>



                               <div style={{ display: "grid", marginTop:'auto' ,  gap:'1rem', padding:'2rem'  , gridTemplateColumns: "1fr 1fr", textAlign: "center", fontSize: "1.7rem" }}>

                                    <p onClick={aceptarSolicitud} style={{backgroundColor:'green', padding:'1rem', color:'white', cursor:'pointer' }} >Aceptar</p>
                                    <p onClick={rechazarSolicitud} style={{backgroundColor:'red', padding:'1rem', color:'white', cursor:'pointer' }} >Rechazar</p>

                               </div>

                           
                    

                    </div>

                   
                }

              

        </div>

    </div>
  )
}
